import React from "react";
import styles from "./Modal.module.css";
function ModalPermission({ onClose, type, value, header }) {
  return (
    <div
      className="fixed w-full h-full z-[99] inset-0 flex justify-center items-center bg-[#0000008f]"
      onClick={() => {
        onClose();
      }}
    >
      <div className="w-[900px] max-h-[600px] p-2 rounded-md bg-white">
        <div className="flex justify-end mt-1 py-1">
          <img
            onClick={() => {
              onClose();
            }}
            className="w-[30px] h-[30px] hover:cursor-pointer"
            src={require("../../../asset/icon/close-icon.svg").default}
          ></img>
        </div>

        <div style={titleStyle} className="mb-3 mx-8">
            {header == "information" ? (`เงื่อนไขและนโยบายของการใช้งานเว็บไซต์`) : (`เงื่อนไขและนโยบายคุ้มครองข้อมูลส่วนบุคคล`) }</div>

        <div className="-mt-2 px-8 py-2 max-h-[460px] text-[18px] leading-relaxed overflow-y-auto text-gray-800">
            {header == "information" ? (
                <div>
                {value.map((item, index) => (
                    <>{type == item.type && <div>{item.information}</div>}</>
                ))}
                </div>
            ) : (
                <div>
                {value.map((item, index) => (
                    <>{type == item.type && <div>{item.consentForm}</div>}</>
                ))}
                </div>
            )}
        </div>
      </div>
    </div>
  );
}

const titleStyle = {
  // width: "100%",
  padding: "8px 18px",
  borderRadius: "12px",
  background:
    "linear-gradient(to right, #bcd9c6 0%, #aed9d4 50%, #98d8d8 100%)",
  color: "#000000",
  // fontFamily: "'Sarabun', sans-serif",
  fontWeight: "bold",
  fontSize: "22px",
  display: "flex",
  alignItems: "center",
};

export default ModalPermission;
